import type { PwaInstallMethod } from "@configs/analytics/events/types";
import { MemberSettingDownloadBannerAction } from "kz-ui-sdk";

export type PwaRuntimeContext = "pwa" | "web";

export const getRuntimeContext = (): PwaRuntimeContext => {
  if (typeof window === "undefined") return "web";
  const isStandalone =
    window.matchMedia?.("(display-mode: standalone)").matches ||
    (window.navigator as Navigator & { standalone?: boolean }).standalone === true;
  return isStandalone ? "pwa" : "web";
};

/** external only when the brand routes installs through a 3P URL; otherwise our native PWA installer. */
export const getPwaInstallMethod = (
  downloadBanner?: { action?: MemberSettingDownloadBannerAction } | null,
): PwaInstallMethod =>
  downloadBanner?.action === MemberSettingDownloadBannerAction.OpenExternalUrl ? "external" : "native";
